// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tvstickybutton_stickyButtonContainer__SN1k0 {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 500px;
  padding: 12px 16px 16px;
  background: #000000;
  z-index: 1000;
}

.tvstickybutton_contextualText__cNlsZ {
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 18px;
  line-height: 15px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.tvstickybutton_nameGradient__9gRo9 {
  background: linear-gradient(98deg, #00C8FF 0%, #CE96FF 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}

.tvstickybutton_restText__zqTAa {
  color: #ffffff;
}

.tvstickybutton_stickyButton__GOWTT {
  width: 100%;
  min-height: 50px;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 19px;
  color: #000;
  box-shadow: none;
  outline: none;
  border: none;
  cursor: pointer;
  border-radius: var(--corner-radius-radius-124172-wxh, 16px);
  border: var(--Stroke-stroke-1, 1px) solid rgba(255, 255, 255, 0.80);
  background: var(--Studio-gradient-CTA-Green-CTA, linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%));
  transition: opacity 0.2s;
}

.tvstickybutton_stickyButton__GOWTT:disabled {
  background: #959595;
  color: rgba(255, 255, 255, 0.5);
  pointer-events: none;
}

.tvstickybutton_stickyButton__GOWTT:hover:not(:disabled) {
  opacity: 0.9;
}

.tvstickybutton_stickyButton__GOWTT:active:not(:disabled) {
  opacity: 0.8;
}

`, "",{"version":3,"sources":["webpack://./src/components/TVStickyButton/tvstickybutton.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,+EAA+E;AACjF;;AAEA;EACE,4DAA4D;EAC5D,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,2DAA2D;EAC3D,mEAAmE;EACnE,qGAAqG;EACrG,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".stickyButtonContainer {\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  max-width: 500px;\n  padding: 12px 16px 16px;\n  background: #000000;\n  z-index: 1000;\n}\n\n.contextualText {\n  font-size: 12px;\n  font-weight: 400;\n  text-align: center;\n  margin-bottom: 18px;\n  line-height: 15px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.nameGradient {\n  background: linear-gradient(98deg, #00C8FF 0%, #CE96FF 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  display: inline-block;\n}\n\n.restText {\n  color: #ffffff;\n}\n\n.stickyButton {\n  width: 100%;\n  min-height: 50px;\n  border-radius: 40px;\n  font-size: 16px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 19px;\n  color: #000;\n  box-shadow: none;\n  outline: none;\n  border: none;\n  cursor: pointer;\n  border-radius: var(--corner-radius-radius-124172-wxh, 16px);\n  border: var(--Stroke-stroke-1, 1px) solid rgba(255, 255, 255, 0.80);\n  background: var(--Studio-gradient-CTA-Green-CTA, linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%));\n  transition: opacity 0.2s;\n}\n\n.stickyButton:disabled {\n  background: #959595;\n  color: rgba(255, 255, 255, 0.5);\n  pointer-events: none;\n}\n\n.stickyButton:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.stickyButton:active:not(:disabled) {\n  opacity: 0.8;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stickyButtonContainer": `tvstickybutton_stickyButtonContainer__SN1k0`,
	"contextualText": `tvstickybutton_contextualText__cNlsZ`,
	"nameGradient": `tvstickybutton_nameGradient__9gRo9`,
	"restText": `tvstickybutton_restText__zqTAa`,
	"stickyButton": `tvstickybutton_stickyButton__GOWTT`
};
export default ___CSS_LOADER_EXPORT___;
